export const handleRetryCta = async () => {
    if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        document.getElementById('YMK-module')?.parentNode?.removeChild(document?.getElementById('YMK-module'));
        document.getElementById('initscript')?.remove();
        await handlers.setRecommendedStyles('');
        await handlers.setShowErrorScreen(false);
        return await handlers.initState();
      }
};